export default __webpack_public_path__ + "static/media/Benin.d9330de9.png";